<template lang="pug">
    .questionnaires(v-if="content")
        .page__wr.questionnaires__wr
            .questionnaires__left
                ul.questionnaires__nav
                    li.questionnaires__nav-item(v-for="(item, index) in content.nav" :key="index" :class="{'questionnaires__nav-item--active': index == content.nav.length-1}")
                        router-link(:to="item.link") {{ item.name }}
                h2.questionnaires__headline {{ content.subtitle }}
                p.questionnaires__description {{ content.description }}
                .questionnaires__block
                    SvgIcon.questionnaires__block-icon(name="email" width="28" height="21")
                    a.questionnaires__block-description(:href="content.email.link") {{ content.email.title }}
                .questionnaires__list-wr
                    ul.questionnaires__list
                        li.questionnaires__list-item(v-for="item in content.sheets")
                            .questionnaires__list-item-block
                                p.questionnaires__list-item-block-text {{ item.name }}
                                a.questionnaires__list-item-block-download(:href="item.file" download target="blank")
                                    SvgIcon.questionnaires__list-item-block-download-icon(name="download" width="28" height="34")
                                    .questionnaires__list-item-block-download-text Скачать
                            router-link.questionnaires__list-item-link(v-if="item.linkProduct" :to="item.linkProduct") Детально ознакомиться с товаром
        .questionnaires__bg-wr
            .questionnaires__bg

</template>

<script>
    import EventBus from '@/eventBus';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    import '@/components/questionnaires/questionnaires.styl';
    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

    export default {
        name: 'Questionnaires',

        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
            }
        },

        components: {
            SvgIcon,
        },

        created() {
            // Загрузка данных для страницы
            this.$nextTick(() => {
                // this.request(this.$router.currentRoute.path);
            });
        },

        mounted() {
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                // экземпляр компонента доступен как `vm`
                EventBus.$emit('pagePreloaderShow');
                vm.scrollbarCheck();
                setTimeout(() => {
                    EventBus.$emit('setMenuTopActiveClass', to.path);
                    vm.request(to.path);
                }, 50);
            })
        },

        beforeRouteUpdate(to, from, next) {
            EventBus.$emit('pagePreloaderShow');
            this.scrollbarCheck();
            setTimeout(() => {
                EventBus.$emit('setMenuTopActiveClass', to.path);
                this.request(to.path);
                next();
            }, 50);
        },

        methods: {
            request(url) {
                this.req('QuestionnairesPage:getQuestionnairesPage', {url}, res => {
                    this.content = res.content;
                    EventBus.$emit('pagePreloaderHide');
                    this.$nextTick(() => {
                        this.checkOverflow(url);
                        let src = '/img/background.png';
                        let $img = $( '<img src="' + src + '">' );
                        $img.bind( 'load', function(){
                            $('.questionnaires__bg' ).css({'background-image': 'url(' + src + ')', 'opacity': '1'} );
                        } );
                        if( $img[0].width ){ $img.trigger( 'load' );}
                    });
                });
            },
        }
    }
</script>
